<template>
  <div :class="classList">
    <div class="o-modal__box">
      <v-loading-spinner v-if="loading" />
      <a class="o-modal__box__close" href="#" tabindex="0" @click.prevent="close">
        <icon name="times" />
      </a>
      <slot name="header" />
      <div ref="content" class="o-modal__box__content">
        <slot name="content" />
      </div>
    </div>
    <div class="o-modal__overlay" />
  </div>
</template>

<script>
import VLoadingSpinner from '../atoms/LoadingSpinner.vue';
import addSlotClasses from '../mixins/slotClassAddition';

export default {
  name: 'v-modal',
  introduction: 'A pop up modal.',
  components: {
    VLoadingSpinner,
  },
  mixins: [addSlotClasses],
  props: {
    name: {
      type: String,
      required: true,
      note: 'The name of the modal to pass to the store.',
    },
    size: {
      type: String,
      note: 'The size of the modal (can be "small")',
    },
    loading: {
      type: Boolean,
      note: 'Toggles display of a loading spinner over the content.',
    },
  },
  data() {
    return {
      headerClass: 'o-modal__box__header',
      active: false,
    };
  },
  created() {
    // This should be handled in the parent. This component should just emit opened and closed events with its name.
    this.$bus.$on('toggleModal', ({ name, active }) => {
      if (name === this.name) {
        this.active = active;
        this.$emit('onOpen');
        this.$store.dispatch('modals/MODAL_HISTORY', name);
      } else {
        this.active = false;
        this.$emit('onClose');
      }
    });
    this.$bus.$on('closeModal', () => {
      this.active = false;
      this.$emit('onClose');
    });
  },
  mounted() {
    this.addSlotClasses();
  },
  computed: {
    classList() {
      const { active, size } = this;
      return {
        'o-modal': true,
        'o-modal--active': active,
        [`o-modal--${size}`]: size,
      };
    },
  },
  methods: {
    close() {
      this.$emit('onClose');
      this.$bus.$emit('closeModal');
      this.$bus.$emit('hideGlobalMessage');
    },
  },
};
</script>

<style scoped>
.o-modal__box {
  background: #fff;
  position: fixed;
  top: 45%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0) scale(0.8);
  border-radius: 9px;
  opacity: 0;
  visibility: hidden;
  width: 650px;
  max-width: calc(100% - 30px);
  max-height: calc(100% - 30px);
  box-shadow: 0 0 20px 2px #222;
  transition: opacity .25s ease-in-out, top .25s ease-in-out, transform .15s ease-in-out;
}

.o-modal__box__header {
  padding: var(--spacing-base);
  border-bottom: 1px solid var(--color-border);
  margin-bottom: 0;
}

.o-modal__box__content {
  padding: var(--spacing-base);
  max-height: calc(100vh - 94px);
  overflow-y: auto;
}

.o-modal__box__close {
  z-index: 3;
  line-height: 0;
  background: #fff;
  border-radius: 30px;
  position: absolute;
  right: calc(0px - var(--spacing-small));
  top: calc(0px - var(--spacing-small));
  padding: var(--spacing-xs);
  border: 3px solid var(--color-error);
  transition: 0.2s all ease;
}

.o-modal__box__close:hover {
  background: var(--color-error);
}

.o-modal__box__close:hover svg {
  color: #fff;
}

.o-modal__box__close svg {
  height: 12px;
  width: 12px;
  color: var(--color-error);
}

.o-modal--active .o-modal__box {
  opacity: 1;
  top: 50%;
  visibility: visible;
  transform: translate3d(-50%, -50%, 0) scale(1);
  z-index: 800;
}

.o-modal--active .o-modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  z-index: 700;
}

.o-modal--small .o-modal__box {
  width: 450px;
}
</style>
